/** 서버가 PDF 대신 BaseResponse JSON(실패)을 내려주면 그 안의 message 를 꺼낸다. 형식을 모르면 undefined. */
export const readErrorMessage = async (blob: Blob): Promise<string | undefined> => {
  try {
    const parsed = JSON.parse(await blob.text());
    return typeof parsed?.message === 'string' ? parsed.message : undefined;
  } catch {
    return undefined;
  }
};
